BaseStep    = App.loadClass("grower::viewmodels/fields/add/steps/BaseStep")
FieldModel  = App.loadClass("grower::viewmodels/fields/add/Field")
StringUtil  = App.load("core::utils/string")

class exports.Form extends KoModel

    history: []
    _temp_history: []
    defaultFirstStep: "selectAddOrUpload"

    setInitialDeps: () ->
        @syncDeps

            # Field
            "FieldModel": FieldModel

            # Steps
            "uploadStart": "grower::viewmodels/fields/add/steps/UploadStart"
            "saveField": "grower::viewmodels/fields/add/steps/SaveField"

    constructor: (handler, data = {}, deps = {}) ->
        super()

        @setInitialDeps()
        @syncDeps deps

        @handler = handler

        @currentStep    = ko.observable()
        @currentStepInstance = ko.observable()
        @currentMode    = ko.observable ""

        @currentField = ko.observable(new (@getDep "FieldModel") data.data)

        @errors     = ko.observableArray([])

        @changeStep @defaultFirstStep

        @year = data.year ? null

    reset: () ->
        @currentField(new (@getDep "FieldModel"))


    registerCustomBindings: () ->
        ko.bindingHandlers.goToStep =
            init: (element, valueAccessor) =>
                value = ko.unwrap valueAccessor()

                $(element).on 'click', () =>
                    if $.isFunction value
                        # scope will only be proper if this method
                        # was created/bound with a fat arrow; () =>
                        value()
                    else
                        @changeStep value



    finish: () =>
        @handler.parent.parent.refresh()

    ###

    Step changing; we try to resolve a dependency matching the step we're trying to change to.
    If there's a dependency that matches, we instantiate that clase, otherwise, we create an instance
    of the generic BaseStep class.

    There are two entities of importance during the switch;
    - the old step we're changing from (oldStep)
    - the new step we're changing to (newStep)

    Here's the order of callbacks:

    - oldStep.beforeNext() (or beforePrev, if goingBackwards)
        - if this returns false (literal false), we don't change steps.
    - newStep.beforeSet()
        - if this returns false (literal false), we don't change steps
    - We set the newStep to be current
    - oldStep.afterNext() (or afterPrev, if goingBackwards)
    - newStep.afterSet()


    ###

    # todo: abstract this. I don't think it belongs here.
    # maybe it could be part of an interface, or just a separate object/class
    # that we instantiate
    changeStep: (stepName, goingBackwards = false, set_cb) =>
        oldStep = @currentStepInstance()
        # Check oldStep.beforeNext (or beforePrev if goingBackwards)
        # and step.beforeSet to see if we can continue
        if oldStep?
            if goingBackwards
                fn = 'beforePrev'
            else
                fn = 'beforeNext'

            if oldStep[fn](stepName) is false
                #console.log "#{fn} failed"
                return

        # Check for a stepchangemodifier that can rewrite how steps work
        if @stepChangeModifier? and $.isFunction @stepChangeModifier
            stepName = @stepChangeModifier(@currentStep(), stepName, goingBackwards)
            if stepName is false
                return

        # Try resolving dependency
        if @getDep(stepName)
            step = new (@getDep stepName) this
        else
            step = new BaseStep this



        if step.beforeSet() is false
            #console.log "beforeset failed"
            return

        if not goingBackwards
            @history.push @currentStep()

        # Set `step` to be current
        @currentStep stepName
        @currentStepInstance step
        @currentStepInstance().__name stepName

        @errors []

        @history = @_temp_history
        # Finish up with oldStep.afterNext() (or afterPrev if goingBackwards)
        # and step.afterSet()
        if oldStep?
            if goingBackwards
                fn = 'afterPrev'
            else
                fn = 'afterNext'
            oldStep[fn]()

        # let us do some custom stuff, if we want
        if set_cb?
            set_cb(step)

        step.afterSet()

    goBack: () =>
        prev = @currentStepInstance().getPrev()

        if not prev?
            return

        @changeStep prev, true

    clearHistoryPrev: () ->
        history = @history.slice()
        prev = history.pop()

        @_temp_history = history

        return prev

    clearHistoryAt: (page) ->
        # copy the array
        history = @history.slice()
        ind     = history.indexOf page

        if ind isnt -1
            history.splice(ind, history.length)

        @_temp_history = history

    clearHistoryAfter: (page) ->
        history = @history.slice()
        ind     = history.indexOf page

        if ind isnt -1
            history.splice(ind + 1, history.length)

        @_temp_history = history

    destroy: () ->
        @currentStepInstance()?.destroy?()
        @currentField().destroy()
